import { useState } from 'react'
import styles from './index.module.css'


const NftItemPreview = ({nftData, actionText, isNFTStaked, handleSelectNFTForStaking, isNFTSelected, handleUnstakeNFT})=>{

    const [isLoading, setIsLoading] =  useState(false)

    return (
        <div className={styles.mainPreviewDiv} >
            <div className={styles.videoBackground} >
<img
src={nftData.image}
            className={styles.videoSection}
            controls
            alt=''
            />   
            


            </div>

            <div>
                <p className={styles.nftGroupName}> {nftData.name} </p>
            </div>

            {
                isNFTSelected === false ? (
                    isNFTStaked === false ? <button className={styles.actionButton} onClick={()=>handleSelectNFTForStaking()} >  
                    {actionText}
                    </button> : <button className={styles.actionButton} onClick={()=>handleUnstakeNFT()} >  
                    {actionText}
                    </button>
                ): ""
            }
            
        
        </div>
    )
}

export default NftItemPreview